export const blockIconsAndroidThermostatNew = (
	<span className='material-symbols-outlined'>thermostat</span>
);
